import keyMirror from '../utils/keyMirror';

export const VIEW = keyMirror({
    HOME_VIEW: null,
    WINDOW_LIST_VIEW: null,
    WINDOW_EDIT_VIEW: null,
    NEW_WINDOW_VIEW: null,
    MY_WINDOW_VIEW: null
});

//
// this is to leverage the OpenShift configMap for environment variables
// @see https://wiki.bnsf.com/display/TW/Nginx+FAQs+For+EDP#NginxFAQsForEDP-CanIuseenvironmentspecificconfigurationforstaticcontentdeployment?
//
export const GET_ENV_VARS_URL = document.location.origin + '/config/serviceUrls.json?' + Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);

export const DATE_FORMAT = 'YYYY-MM-DD';
export const TIME_FORMAT = 'HH:mm';